import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { appendAvatarToFormData } from '../../../../utils/fileUpload'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface CreateCategoryData {
  avatar?: {
    uri: string
    type?: string
  }
  name: string
  contactAccountIds?: string[]
}

const createCategory = async (data: CreateCategoryData): Promise<string> => {
  const formData = new FormData()
  formData.append('name', data.name)
  if (data.contactAccountIds && data.contactAccountIds.length > 0) {
    data.contactAccountIds.forEach((id) => {
      formData.append('contactAccountIds[]', id)
    })
  }
  if (data.avatar) {
    // Append avatar using shared utility
    appendAvatarToFormData(formData, data.avatar.uri, 'avatar')
  }

  const { data: responseData } = await api.post<string>('/category', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return responseData
}

export const useCreateCategory = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<string, Error, CreateCategoryData>({
    mutationFn: createCategory,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.categoryCreated'))
      await queryClient.invalidateQueries({ queryKey: ['categories'] })
    },
  })
}
